interface Props {
  readonly size?: 'small' | 'medium' | 'large';
}

export function Space(props: Props) {
  switch (props.size) {
    case 'large':
      return <div className="h-8" />;
    case 'medium':
      return <div className="h-4" />;
    case 'small':
    default:
      return <div className="h-2" />;
  }
}
